import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { COLOR_PALETTE_PRESETS } from '../../utils/corporateSectionSettings';

interface ColorPalettePickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  allowClear?: boolean;
  clearLabel?: string;
}

const ColorPalettePicker: React.FC<ColorPalettePickerProps> = ({
  label,
  value,
  onChange,
  allowClear = false,
  clearLabel = 'Kaldır',
}) => {
  const solidColor = value.startsWith('#') ? value : '#3b82f6';

  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
        {COLOR_PALETTE_PRESETS.map((preset) => (
          <Button
            key={preset.label}
            size="small"
            variant={value === preset.value ? 'contained' : 'outlined'}
            onClick={() => onChange(preset.value)}
            sx={{
              minWidth: 72,
              borderColor: 'divider',
              background: preset.value.startsWith('linear-gradient') ? preset.value : preset.value,
              color: ['#ffffff', '#f1f5f9'].includes(preset.value) ? '#111827' : '#fff',
              '&:hover': {
                opacity: 0.92,
              },
            }}
          >
            {preset.label}
          </Button>
        ))}
        {allowClear && (
          <Button size="small" variant="outlined" color="error" onClick={() => onChange('')}>
            {clearLabel}
          </Button>
        )}
      </Box>
      <TextField
        fullWidth
        size="small"
        label="Özel renk / gradient"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        helperText="Hex renk (#3b82f6) veya CSS gradient kullanabilirsiniz"
        InputProps={{
          startAdornment: value.startsWith('#') ? (
            <Box
              component="input"
              type="color"
              value={solidColor}
              onChange={(e) => onChange(e.target.value)}
              sx={{ border: 'none', width: 24, height: 24, p: 0, background: 'none', cursor: 'pointer', mr: 1 }}
            />
          ) : undefined,
        }}
      />
    </Box>
  );
};

export default ColorPalettePicker;
